import { render } from "./IconViewList.vue?vue&type=template&id=113166de"
import script from "./IconViewList.vue?vue&type=script&lang=js"
export * from "./IconViewList.vue?vue&type=script&lang=js"
script.render = render

export default script